import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { fontColors } from '@sphereon/ui-components.core';
const MeatBallsIcon = (props) => {
    const { width = 20, height = 5, color = fontColors.dark, style } = props;
    return (_jsx("div", { style: { ...style, width, height, display: 'flex' }, children: _jsxs("svg", { width: "100%", height: "100%", viewBox: "0 0 20 5", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("circle", { cx: "2", cy: "2.5", r: "2", fill: color }), _jsx("circle", { cx: "10", cy: "2.5", r: "2", fill: color }), _jsx("circle", { cx: "18", cy: "2.5", r: "2", fill: color })] }) }));
};
export default MeatBallsIcon;
